import ButtonExportExcel from '../../../../components/ui/ButtonExportExcel'
import { exportExcelBookListBorrow } from '../../../../service/ExportExcelBookListBorrow'
const ExportExcelBookBorrow = () => {
  const handleExport = async () => {
    try {
      const res = await exportExcelBookListBorrow.getAll()
      if (res?.status !== 200) {
        console.error('Export failed:', res?.status)
      }
      const blob = await res.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      const now = new Date()

      const day = String(now.getDate()).padStart(2, '0')
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const year = now.getFullYear()
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')

      const formatted = `${day}${month}${year}${hours}${minutes}${seconds}`
      a.download = `books_borrow${formatted}.xlsx`
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error when exporting excel', error)
    }
  }
  return <ButtonExportExcel onClick={handleExport} />
}

export default ExportExcelBookBorrow
